export default __webpack_public_path__ + "static/media/bookmark.46a0ce63.svg";